import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material"
import MDBox from "../MDBox"
import {
  ReactComponent as CustomHomeIcon,
} from "components/icons/svgs/class.svg"
import {
  ReactComponent as CustomDateIcon,
} from "components/icons/svgs/calendar.svg"
import {
  ReactComponent as CustomDateCheckIcon,
} from "components/icons/svgs/calendar-check.svg"
import {
  ReactComponent as CustomEventIcon,
} from "components/icons/svgs/event.svg"
import {
  ReactComponent as CustomClockIcon,
} from "components/icons/svgs/clock.svg"
import {
  ReactComponent as CustomReportIcon,
} from "components/icons/svgs/report.svg"

const ModalLeaveRelatedInfomationContent = ({ uiData }) => {
  return (
    <MDBox className="modal-leave-related-information-content">
      {/* Classes That Need Cover */}
      <Accordion
        className="accordion"
        defaultExpanded
        sx={{ border: "unset", boxShadow: "unset" }}
      >
        <AccordionSummary className="accordion-header">
          <Typography className="accordion-header-title" variant="h6">
            Classes that need cover
          </Typography>
        </AccordionSummary>

        <AccordionDetails sx={{ p: 0, borderColor: "transparent" }}>
          <div className="accordion-list">
            {uiData.classesThatNeedCover.length === 0 ? (
              <Typography sx={{ p: 2 }} variant="body2">
                No data
              </Typography>
            ) : (
              uiData.classesThatNeedCover.map((item, index) => (
                <div key={index} className="accordion-list-item">
                  <MDBox className="accordion-list-item-content">
                    <Typography
                      className="accordion-list-item-content-line"
                      variant="body2"
                    >
                      <CustomHomeIcon /> Class Name: <b>{item.className}</b>
                    </Typography>
                    <Typography
                      className="accordion-list-item-content-line"
                      variant="body2"
                    >
                      <CustomDateIcon /> Date: <b>{item.date}</b>
                    </Typography>
                    <Typography
                      className="accordion-list-item-content-line"
                      variant="body2"
                    >
                      <CustomDateCheckIcon /> Schedule:{" "}
                      <b>{item.classSchedule}</b>
                    </Typography>
                  </MDBox>
                </div>
              ))
            )}
          </div>
        </AccordionDetails>
      </Accordion>

      <MDBox className="accordion-divider" />

      {/* Events */}
      <Accordion
        className="accordion"
        defaultExpanded
        sx={{ border: "unset", boxShadow: "unset" }}
      >
        <AccordionSummary className="accordion-header">
          <Typography className="accordion-header-title" variant="h6">
            Events
          </Typography>
        </AccordionSummary>

        <AccordionDetails sx={{ p: 0, borderColor: "transparent" }}>
          <List className="accordion-list">
            {uiData.events.length === 0 ? (
              <Typography sx={{ p: 2 }} variant="body2">
                No data
              </Typography>
            ) : (
              uiData.events.map((item, index) => (
                <ListItem key={index} className="accordion-list-item">
                  <ListItemText
                    secondary={
                      <MDBox className="accordion-list-item-content">
                        <Typography
                          className="accordion-list-item-content-line"
                          variant="body2"
                        >
                          <CustomEventIcon /> Event type:{" "}
                          <b>{item.eventType}</b>
                        </Typography>
                        <Typography
                          className="accordion-list-item-content-line"
                          variant="body2"
                        >
                          <CustomHomeIcon /> Class Name:{" "}
                          <b>{item.className}</b>
                        </Typography>
                        <Typography
                          className="accordion-list-item-content-line"
                          variant="body2"
                        >
                          <CustomDateIcon /> Date: <b>{item.date}</b>
                        </Typography>
                        <Typography
                          className="accordion-list-item-content-line"
                          variant="body2"
                        >
                          <CustomClockIcon /> Time: <b>{item.eventTime}</b>
                        </Typography>
                      </MDBox>
                    }
                  />
                </ListItem>
              ))
            )}
          </List>
        </AccordionDetails>
      </Accordion>

      <MDBox className="accordion-divider" />

      {/* Reports */}
      <Accordion
        className="accordion"
        defaultExpanded
        sx={{ border: "unset", boxShadow: "unset" }}
      >
        <AccordionSummary className="accordion-header">
          <Typography className="accordion-header-title" variant="h6">
            Reports
          </Typography>
        </AccordionSummary>

        <AccordionDetails sx={{ p: 0, borderColor: "transparent" }}>
          <List className="accordion-list">
            {uiData.reports.length === 0 ? (
              <Typography sx={{ p: 2 }} variant="body2">
                No data
              </Typography>
            ) : (
              uiData.reports.map((item, index) => (
                <ListItem key={index} className="accordion-list-item">
                  <ListItemText
                    secondary={
                      <MDBox className="accordion-list-item-content">
                        <Typography
                          className="accordion-list-item-content-line"
                          variant="body2"
                        >
                          <CustomHomeIcon /> Class: <b>{item.className}</b>
                        </Typography>
                        <Typography
                          className="accordion-list-item-content-line"
                          variant="body2"
                        >
                          <CustomReportIcon /> Report Type:{" "}
                          <b>{item.reportType}</b>
                        </Typography>
                        <Typography
                          className="accordion-list-item-content-line"
                          variant="body2"
                        >
                          <CustomClockIcon /> Due Date: <b>{item.dueDate}</b>
                        </Typography>
                      </MDBox>
                    }
                  />
                </ListItem>
              ))
            )}
          </List>
        </AccordionDetails>
      </Accordion>
    </MDBox>
  )
}

export default ModalLeaveRelatedInfomationContent
